export default __webpack_public_path__ + "static/media/card-2.46f5e77c.png";